import { render, staticRenderFns } from "./Content_en.vue?vue&type=template&id=e5c2f2c2&"
import script from "./Content_en.vue?vue&type=script&lang=js&"
export * from "./Content_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports